// extracted by mini-css-extract-plugin
module.exports = {"mobile":"_11Sg0d","item":"_3eWHzi","link":"_3nbU4K","desktop":"_3ocpsJ"};